import styled from "styled-components";
import { breakpoints } from "../../../../../shared-logic/themes/lexusTheme";

export const Wrapper = styled.article`
    display: flex;
    flex-direction: column;
    row-gap: var(--spacing-3);

    @supports not (padding-inline: 0) {
        & > *:not(:nth-last-child(1)) {
            margin-bottom: var(--spacing-3);
        }
    }
`;

export const ServicesList = styled.ul`
    display: grid;
    grid-template-columns: 1fr;
    row-gap: var(--spacing-2);
    column-gap: var(--spacing-2);
    margin: 0;
    padding: 0;
    list-style: none;

    /* Card */
    li {
        & > div {
            height: 100%;
        }
    }

    @media screen and (min-width: ${breakpoints.md}) {
        grid-template-columns: repeat(auto-fit, minmax(calc(50% - var(--spacing-2)), 1fr));
    }

    @media screen and (min-width: ${breakpoints.xl}) {
        grid-template-columns: repeat(auto-fit, minmax(calc(25% - var(--spacing-2)), 1fr));
    }

    @supports not (padding-inline: 0) {
        li:not(:nth-last-child(1)) {
            margin-bottom: var(--spacing-2);
            margin-right: var(--spacing-2);
        }
    }
`;
